import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormTitle, FormSubtitle, FormGroup, FormRow, Label, StyledInput, StyledSelect, ErrorText, CheckboxLabel } from '../styles';
import { PhoneInput } from '../../../../common/PhoneInput';

const Step1EntityDetails = () => {
    const { register, watch, formState: { errors } } = useFormContext();
    const hasDifferentOperatingAddress = watch('hasDifferentOperatingAddress');


    return (
        <div>
            <FormTitle>Entity Details</FormTitle>
            <FormSubtitle>Provide the legal details of your company.</FormSubtitle>

            <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', marginTop: '24px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px' }}>
                Applicant Information
            </h3>
            <FormRow>
                <FormGroup>
                    <Label htmlFor="applicantName">Applicant Full Name</Label>
                    <StyledInput type="text" {...register('applicantName')} placeholder="Jane Doe" $error={!!errors.applicantName} />
                    {errors.applicantName && <ErrorText>{errors.applicantName.message}</ErrorText>}
                </FormGroup>
                <FormGroup>
                    <Label htmlFor="applicantTitle">Applicant Title / Role</Label>
                    <StyledInput type="text" {...register('applicantTitle')} placeholder="Founder / CEO" $error={!!errors.applicantTitle} />
                    {errors.applicantTitle && <ErrorText>{errors.applicantTitle.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px', marginTop: '32px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '8px' }}>
                Legal Entity
            </h3>

            <FormGroup>
                <Label htmlFor="legalName">Legal Business Name</Label>
                <StyledInput
                    type="text"
                    {...register('legalName')}
                    placeholder="e.g. Acme Corporation"
                    $error={!!errors.legalName}
                />
                {errors.legalName && <ErrorText>{errors.legalName.message}</ErrorText>}
            </FormGroup>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="dba">Doing Business As (DBA) <span style={{ opacity: 0.6, fontWeight: 'normal' }}>— Optional</span></Label>
                    <StyledInput type="text" {...register('dba')} placeholder="e.g. Acme Tech" />
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="entityType">Entity Type</Label>
                    <StyledSelect {...register('entityType')} $error={!!errors.entityType}>
                        <option value="">Select type</option>
                        <option value="llc">Limited Liability Company (LLC)</option>
                        <option value="c_corp">C-Corporation</option>
                        <option value="s_corp">S-Corporation</option>
                        <option value="partnership">Partnership</option>
                        <option value="sole_proprietor">Sole Proprietorship</option>
                    </StyledSelect>
                    {errors.entityType && <ErrorText>{errors.entityType.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="taxId">Tax ID / EIN</Label>
                    <StyledInput type="text" {...register('taxId')} placeholder="XX-XXXXXXX" $error={!!errors.taxId} />
                    {errors.taxId && <ErrorText>{errors.taxId.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="incorporationDate">Date of Incorporation</Label>
                    <StyledInput type="date" {...register('incorporationDate')} $error={!!errors.incorporationDate} />
                    {errors.incorporationDate && <ErrorText>{errors.incorporationDate.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="jurisdiction">Jurisdiction </Label>
                    <StyledInput type="text" {...register('jurisdiction')} placeholder="e.g. Delaware" $error={!!errors.jurisdiction} />
                    {errors.jurisdiction && <ErrorText>{errors.jurisdiction.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="lei">LEI  <span style={{ opacity: 0.6, fontWeight: 'normal' }}>— Optional</span></Label>
                    <StyledInput type="text" {...register('lei')} placeholder="20 character LEI" $error={!!errors.lei} />
                </FormGroup>
            </FormRow>

            <FormGroup>
                <Label htmlFor="address">Registered Business Address</Label>
                <StyledInput type="text" {...register('address')} placeholder="Street Address" $error={!!errors.address} />
                {errors.address && <ErrorText>{errors.address.message}</ErrorText>}
            </FormGroup>

            <FormRow>
                <FormGroup>
                    <Label htmlFor="city">City</Label>
                    <StyledInput type="text" {...register('city')} placeholder="City" $error={!!errors.city} />
                    {errors.city && <ErrorText>{errors.city.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="state">State / Province</Label>
                    <StyledInput type="text" {...register('state')} placeholder="State" $error={!!errors.state} />
                    {errors.state && <ErrorText>{errors.state.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="zipCode">ZIP / Postal Code</Label>
                    <StyledInput type="text" {...register('zipCode')} placeholder="ZIP Code" $error={!!errors.zipCode} />
                    {errors.zipCode && <ErrorText>{errors.zipCode.message}</ErrorText>}
                </FormGroup>
            </FormRow>

            <CheckboxLabel style={{ marginBottom: '24px' }}>
                <input type="checkbox" {...register('hasDifferentOperatingAddress')} />
                <span>Operating address is different from registered legal address</span>
            </CheckboxLabel>

            {hasDifferentOperatingAddress && (
                <div style={{ padding: '16px', backgroundColor: 'rgba(255,255,255,0.02)', borderRadius: '12px', marginBottom: '24px', border: '1px solid rgba(255,255,255,0.08)' }}>
                    <h4 style={{ margin: '0 0 16px 0', fontSize: '14px', fontWeight: '500' }}>Primary Operating Address</h4>
                    <FormGroup>
                        <Label htmlFor="operatingAddress">Operating Street Address</Label>
                        <StyledInput type="text" {...register('operatingAddress')} placeholder="Street Address" $error={!!errors.operatingAddress} />
                        {errors.operatingAddress && <ErrorText>{errors.operatingAddress.message}</ErrorText>}
                    </FormGroup>

                    <FormRow>
                        <FormGroup>
                            <Label htmlFor="operatingCity">City</Label>
                            <StyledInput type="text" {...register('operatingCity')} placeholder="City" $error={!!errors.operatingCity} />
                            {errors.operatingCity && <ErrorText>{errors.operatingCity.message}</ErrorText>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="operatingState">State / Province</Label>
                            <StyledInput type="text" {...register('operatingState')} placeholder="State" $error={!!errors.operatingState} />
                            {errors.operatingState && <ErrorText>{errors.operatingState.message}</ErrorText>}
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="operatingZipCode">ZIP / Postal Code</Label>
                            <StyledInput type="text" {...register('operatingZipCode')} placeholder="ZIP Code" $error={!!errors.operatingZipCode} />
                            {errors.operatingZipCode && <ErrorText>{errors.operatingZipCode.message}</ErrorText>}
                        </FormGroup>
                    </FormRow>
                </div>
            )}

            <FormRow>
                <FormGroup>
                    <Label>Company Phone Number</Label>
                    <PhoneInput
                        dialCodeName="companyPhoneDialCode"
                        numberName="companyPhone"
                        register={register}
                        errors={errors}
                    />
                    {errors.companyPhone && <ErrorText>{errors.companyPhone.message}</ErrorText>}
                </FormGroup>

                <FormGroup>
                    <Label htmlFor="companyEmail">Company Email / Point of Contact</Label>
                    <StyledInput type="email" {...register('companyEmail')} placeholder="contact@company.com" $error={!!errors.companyEmail} />
                    {errors.companyEmail && <ErrorText>{errors.companyEmail.message}</ErrorText>}
                </FormGroup>
            </FormRow>
        </div>
    );
};

export default Step1EntityDetails;
